import { NgModule, ModuleWithProviders } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { CommonModule } from '@angular/common';
import { ModalModule, TabsModule, AlertModule, AccordionModule, TypeaheadModule } from 'ngx-bootstrap';
import { AngularModule } from '../../modules/angular/angular.module';
import { MaterialModule } from '../../modules/material/material.module';
import { FileSelectDirective , FileDropDirective } from 'ng2-file-upload';
import { OrderModule } from 'ngx-order-pipe';
import { ChartsModule } from 'ng2-charts';

/* Header */
import { MessagesComponent } from '../../components/messages/messages.component';
import { ConversazioniComponent } from '../../components/conversazioni/conversazioni.component';
import { ConfirmComponent } from '../../components/confirm/confirm.component';

/* Loader */
import { GenericLoaderComponent } from '../../components/loaders/generic-loader/generic-loader.component';
import { LoaderWrapperComponent } from '../../components/loaders/loader-wrapper/loader-wrapper.component';
import { LoaderFullComponent } from '../../components/loaders/loader-full/loader-full.component';

/* Core */
import { NavbarComponent } from '../../components/navbar/navbar.component';
import { HeaderComponent } from '../../components/header/header.component';
import { ContentComponent } from '../../components/content/content.component';
import { FooterComponent } from '../../components/footer/footer.component';

import { UncertificatedComponent } from '../../components/uncertificated/uncertificated.component';
import { AppComponentGenericComponent } from '../../components/custom/app-component-generic/app-component-generic.component';
import { ModalWrapperComponent } from '../../components/modals/modal-wrapper/modal-wrapper.component';
import { TableGenericComponent } from '../../components/custom/table-generic/table-generic.component';
import { FilterBoxGenericComponent } from '../../components/custom/filter-box-generic/filter-box-generic.component';
import { DetailGenericComponent } from '../../components/custom/detail-generic/detail-generic.component';

/* Modal */
import { FindContribuenteComponent } from '../../components/modals/find-contribuente/find-contribuente.component';
import { ModificaCampoComponent } from '../../components/modals/modifica-campo/modifica-campo.component';
import { PraticaModificaComponent } from '../../components/modals/pratica-modifica/pratica-modifica.component';
import { CambiaStatoComponent } from '../../components/modals/cambia-stato/cambia-stato.component';
import { CronologiaPraticaComponent } from '../../components/modals/cronologia-pratica/cronologia-pratica.component';
import { AvanzaPraticheComponent } from '../../components/modals/avanza-pratiche/avanza-pratiche.component';
import { ContribuenteAssociatiComponent } from '../../components/modals/contribuente-associati/contribuente-associati.component';
import { ContribuenteImmobiliComponent } from '../../components/modals/contribuente-immobili/contribuente-immobili.component';
import { ContribuenteLocatariComponent } from '../../components/modals/contribuente-locatari/contribuente-locatari.component';
import { ContribuenteMobiliComponent } from '../../components/modals/contribuente-mobili/contribuente-mobili.component';
import { ContribuenteStipendiComponent } from '../../components/modals/contribuente-stipendi/contribuente-stipendi.component';
import { ContribuenteContiCorrentiComponent } from '../../components/modals/contribuente-conti-correnti/contribuente-conti-correnti.component';
import { NotificaDettaglioComponent } from '../../components/modals/notifica-dettaglio/notifica-dettaglio.component';
import { NotificaAddComponent } from '../../components/modals/notifica-add/notifica-add.component';
import { PagamentoDettaglioComponent } from '../../components/modals/pagamento-dettaglio/pagamento-dettaglio.component';
import { PagamentoAddComponent } from '../../components/modals/pagamento-add/pagamento-add.component';
import { EditaStatoComponent } from '../../components/modals/edita-stato/edita-stato.component';
import { NuovoFlussoComponent } from '../../components/modals/nuovo-flusso/nuovo-flusso.component';
import { CaricaFlussoComponent } from '../../components/modals/carica-flusso/carica-flusso.component';
import { SalvaFlussoComponent } from '../../components/modals/salva-flusso/salva-flusso.component';
import { GestisciFlussiComponent } from '../../components/modals/gestisci-flussi/gestisci-flussi.component';
import { GestisciUtenteComponent } from '../../components/modals/gestisci-utente/gestisci-utente.component';
import { ContribuenteAnagraficaComponent } from '../../components/situazione-contribuente/contribuente-anagrafica/contribuente-anagrafica.component';
import { PraticheDocumentComponent } from '../../components/pratiche/pratiche-document/pratiche-document.component';
import { RendicontazioneDettaglioComponent } from '../../components/statistiche-rendicondazione/rendicontazione-generale/rendicontazione-dettaglio/rendicontazione-dettaglio.component';
import { ContribuentePraticaDettaglioComponent } from '../../components/situazione-contribuente/contribuente-pratica-dettaglio/contribuente-pratica-dettaglio.component';
import { PraticaViewComponent } from '../../components/modals/pratica-view/pratica-view.component';

import { PraticheTabsComponent } from '../../components/pratiche/pratiche-tabs/pratiche-tabs.component';
import { PraticheDetailComponent } from '../../components/pratiche/pratiche-detail/pratiche-detail.component';
import { PraticheInstalmentComponent } from '../../components/pratiche/pratiche-instalment/pratiche-instalment.component';
import { PratichePaymentComponent } from '../../components/pratiche/pratiche-payment/pratiche-payment.component';
import { ContribuentePraticheComponent } from '../../components/situazione-contribuente/contribuente-pratiche/contribuente-pratiche.component';

/* Filter */
import { AnagraficaFilterComponent } from '../../components/filters/anagrafica-filter/anagrafica-filter.component';
import { PraticheFilterComponent } from '../../components/filters/pratiche-filter/pratiche-filter.component';
import { FindContribuenteFilterComponent } from '../../components/filters/find-contribuente-filter/find-contribuente-filter.component';
import { RendicontazioneGeneraleFilterComponent } from '../../components/filters/rendicontazione-generale-filter/rendicontazione-generale-filter.component';
import { RendicontazioneDettaglioFilterComponent } from '../../components/filters/rendicontazione-dettaglio-filter/rendicontazione-dettaglio-filter.component';
import { GestioneUtentiFilterComponent } from '../../components/filters/gestione-utenti-filter/gestione-utenti-filter.component';

import { routing } from './core.routing';

@NgModule({
imports: [
    routing,
    CommonModule,
    AngularModule,
    MaterialModule,
    OrderModule,
    ChartsModule,
    ModalModule.forRoot(),
    TabsModule.forRoot(),
    AlertModule.forRoot(),
    AccordionModule.forRoot(),
    TypeaheadModule.forRoot(),
],
declarations: [
    FileSelectDirective,
    NavbarComponent,
    HeaderComponent,
    ContentComponent,
    FooterComponent,
    UncertificatedComponent,
    MessagesComponent,
    ConversazioniComponent,
    ConfirmComponent,
    GenericLoaderComponent,
    LoaderWrapperComponent,
    LoaderFullComponent,
    AppComponentGenericComponent,
    ModalWrapperComponent,
    TableGenericComponent,
    FilterBoxGenericComponent,
    DetailGenericComponent,
    AnagraficaFilterComponent,
    PraticheFilterComponent,
    FindContribuenteFilterComponent,
    RendicontazioneGeneraleFilterComponent,
    RendicontazioneDettaglioFilterComponent,
    GestioneUtentiFilterComponent,

    FindContribuenteComponent,
    ModificaCampoComponent,
    AvanzaPraticheComponent,
    EditaStatoComponent,
    NuovoFlussoComponent,
    CaricaFlussoComponent,
    SalvaFlussoComponent,
    GestisciFlussiComponent,
    NotificaDettaglioComponent,
    PagamentoDettaglioComponent,
    ContribuenteStipendiComponent,
    ContribuenteContiCorrentiComponent,
    PraticheDocumentComponent,
    RendicontazioneDettaglioComponent,
    ContribuenteAnagraficaComponent,
    ContribuentePraticaDettaglioComponent,

    NotificaAddComponent,
    ContribuenteAssociatiComponent,
    ContribuenteImmobiliComponent,
    ContribuenteLocatariComponent,
    ContribuenteMobiliComponent,
    PagamentoAddComponent,
    CambiaStatoComponent,
    CronologiaPraticaComponent,
    PraticaModificaComponent,
    GestisciUtenteComponent,
    PraticaViewComponent,
    PraticheTabsComponent,
    PraticheDetailComponent,
    PraticheInstalmentComponent,
    PratichePaymentComponent,
    ContribuentePraticheComponent,
],
exports: [
    CommonModule,
    AngularModule,
    MaterialModule,
    ModalModule,
    OrderModule,
    ChartsModule,
    TabsModule,
    AlertModule,
    AccordionModule,
    TypeaheadModule,
    FileSelectDirective,
    NavbarComponent,
    HeaderComponent,
    ContentComponent,
    FooterComponent,
    UncertificatedComponent,
    MessagesComponent,
    ConversazioniComponent,
    ConfirmComponent,
    GenericLoaderComponent,
    LoaderWrapperComponent,
    LoaderFullComponent,
    AppComponentGenericComponent,
    ModalWrapperComponent,
    TableGenericComponent,
    DetailGenericComponent,
    FilterBoxGenericComponent,
    AnagraficaFilterComponent,
    PraticheFilterComponent,
    FindContribuenteFilterComponent,
    CaricaFlussoComponent,
    SalvaFlussoComponent,
    GestisciFlussiComponent,
    NotificaDettaglioComponent,
    PagamentoDettaglioComponent,
    ContribuenteStipendiComponent,
    ContribuenteContiCorrentiComponent,
    PraticheDocumentComponent,
    RendicontazioneDettaglioComponent,
    ContribuentePraticaDettaglioComponent,

    FindContribuenteComponent,
    ModificaCampoComponent,
    AvanzaPraticheComponent,
    EditaStatoComponent,
    NuovoFlussoComponent,
    ContribuenteAnagraficaComponent,

    NotificaAddComponent,
    ContribuenteAssociatiComponent,
    ContribuenteImmobiliComponent,
    ContribuenteLocatariComponent,
    ContribuenteMobiliComponent,
    PagamentoAddComponent,
    CambiaStatoComponent,
    CronologiaPraticaComponent,
    PraticaModificaComponent,
    GestisciUtenteComponent,
    PraticaViewComponent,
    PraticheTabsComponent,
    PraticheDetailComponent,
    PraticheInstalmentComponent,
    PratichePaymentComponent,
    ContribuentePraticheComponent,
],
})
export class CoreModule { }
